export enum ModalTypes {
    Base = "",
    Bottom = "-bottom",
    Left = "-left",
    Fullscreen = "-fullscreen",
    Search = "-search",
    Chat = "-chat",
}
